<div class="popup-component">
    <h3
      *ngFor="let msg of msgs"
      [hidden]="!msg"
      class="title"
    >
        {{ msg }}
    </h3>
    <div class="buttons">
        <button
          mat-button
          class="confirm"
          (click)="dialogRef.close(true)"
        >
          Yes
        </button>

        <button
          mat-button
          class="cancel"
          (click)="dialogRef.close(false)"
        >
          No
        </button>
    </div>
</div>
